import { Component, OnInit } from '@angular/core';
import { ServiceGrouping } from 'src/app/shared/model/service';
import { ErrorService } from 'src/app/shared/services/error.service';
import ServiceData from '../../../assets/services.json';


@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  serviceGroupings: ServiceGrouping[]

  constructor(private errorService: ErrorService) { }

  ngOnInit() {
    this.serviceGroupings = ServiceData;
  }


}
